module.exports = __webpack_public_path__ + "img/apex-config.e92477e2.svg";